export default {
  "common": {
    "documentTitle": "iOS Sub",
    "back": "← 返回",
    "backHome": "← 返回首页",
    "loading": "加载中...",
    "submitting": "提交中...",
    "querying": "查询中...",
    "retry": "重新查询",
    "selectPlaceholder": "请选择"
  },
  "language": {
    "switchToEnglish": "切换到英文",
    "switchToChinese": "切换到中文"
  },
  "theme": {
    "switchToLight": "切换到亮色",
    "switchToDark": "切换到暗色",
    "lightMode": "日间模式",
    "darkMode": "暗色模式"
  },
  "home": {
    "brand": "iOS Sub",
    "topLabel": "",
    "brandSub": "",
    "heroTitle": "ChatGPT iOS 自助激活",
    "heroSub": "输入兑换码并提交 Session 后，系统自动完成充值。",
    "trust": {
      "official": "独立通道",
      "fast": "快速验证",
      "trackable": "订单可查"
    },
    "flowTitle": "操作流程",
    "tabsAria": "兑换站功能",
    "announcementLabel": "公告",
    "announcementAria": "兑换页公告",
    "services": {
      "recharge": {
        "title": "立即兑换",
        "en": "Service Portal",
        "cta": "开始兑换",
        "p1": "验证兑换码",
        "p2": "提交 Session",
        "p3": "确认提交申请"
      },
      "lookup": {
        "title": "订单查询",
        "en": "Task Lookup",
        "cta": "查询状态",
        "p1": "通过兑换码查询",
        "p2": "查看订单状态",
        "p3": "跟踪处理进度"
      }
    },
    "flows": {
      "submit": {
        "title": "提交流程",
        "s1": "验证兑换码 — 匹配套餐和状态",
        "s2": "提交 Session — 粘贴 chatgpt.com/api/auth/session 的 JSON",
        "s3": "确认提交 — 阅读协议后确认"
      },
      "lookup": {
        "title": "查询流程",
        "s1": "输入兑换码 — 输入购买时获得的兑换码",
        "s2": "查询订单 — 点击查询按钮",
        "s3": "查看状态 — 展示对应订单状态"
      }
    }
  },
  "queue": {
    "pendingLabel": "实时库存",
    "unit": "张",
    "loading": "同步中",
    "syncing": "实时库存",
    "reconnecting": "库存已同步"
  },
  "recharge": {
    "title": "立即兑换",
    "subtitle": "ChatGPT 账户自助升级",
    "steps": {
      "s1": "验证兑换码",
      "s2": "提交 Session",
      "s3": "确认兑换"
    },
    "overline": "按步骤完成充值",
    "cardTitle": "兑换码充值",
    "cardHint": "",
    "readyBadge": "等待验证",
    "step1Title": "输入兑换码",
    "codePlaceholder": "请输入兑换码",
    "cdkLabel": "兑换码",
    "cdkValid": "✓ 兑换码有效",
    "cdkPending": "该兑换码正在处理中",
    "cdkPendingHint": "正在自动检测，若订单失败将自动恢复为可提交，无需刷新页面",
    "planType": "套餐类型",
    "verifying": "验证中...",
    "verifyButton": "验证兑换码",
    "safeHint": "",
    "next": "下一步 →",
    "prev": "← 上一步",
    "restart": "重新兑换",
    "step2Title": "提交 Session",
    "progressAria": "充值进度",
    "sessionGuidePrefix": "登录 ChatGPT 后，在浏览器打开",
    "sessionGuideSuffix": "，将页面返回的完整 JSON 全部复制，粘贴到下方输入框。",
    "sessionLabel": "Session JSON",
    "step3Title": "确认提交",
    "sessionStatus": "Session 状态",
    "sessionFilled": "✓ 已填写",
    "submitSuccessTitle": "✓ 申请已提交成功！",
    "taskId": "任务ID",
    "submitSuccessHint": "您可以在“任务查询”页面查看处理进度",
    "confirmSubmit": "确认提交",
    "coverConfirmMessage": "检测到该账号当前为 Plus/Pro 会员，继续充值将覆盖原订阅会员时间，原会员的剩余时长无法保留。\n确认要继续吗？",
    "errInvalidCdk": "兑换码无效",
    "errExternalCdkOnly": "兑换码格式不正确",
    "errVerifyFailed": "验证失败",
    "errCreateFailed": "创建任务失败",
    "errConfirmFailed": "提交失败",
    "errNetwork": "网络错误",
    "errSessionRequired": "请粘贴完整的 Session JSON",
    "errSessionInvalidJson": "Session JSON 格式不正确，请复制完整 JSON 后再提交",
    "errSessionMissingAccessToken": "Session JSON 格式不完整：未找到 accessToken",
    "errSessionMissingEmail": "Session JSON 格式不完整：未找到账号邮箱",
    "errSessionMissingPlanType": "Session JSON 格式不完整：未找到 planType",
    "errSessionPlanNotFree": "当前账号 planType 为 {planType}，提交前将提示确认是否覆盖"
  },
  "history": {
    "title": "订单查询",
    "subtitle": "通过兑换码查询当前订单状态",
    "queryTitle": "兑换码查询",
    "queryHint": "输入购买后获得的兑换码，系统会在当前页面展示对应订单状态。",
    "queryPlaceholder": "请输入需要查询的兑换码",
    "batchQueryTitle": "批量兑换码查询",
    "batchQueryHint": "支持一次粘贴多条兑换码（最多 100 条），使用换行、空格、逗号或分号分隔；系统会自动去重并展示每条订单状态。",
    "batchQueryPlaceholder": "每行一个兑换码，或用逗号分隔多条兑换码",
    "detectedCodes": "已识别 {count} 条唯一兑换码",
    "clearQuery": "清空查询",
    "cdkLabel": "兑换码",
    "queryBtn": "查询订单",
    "batchQueryBtn": "批量查询",
    "queryErrorTitle": "查询失败",
    "resultTitle": "查询结果",
    "liveRefreshing": "处理中任务自动刷新中…",
    "batchResultTitle": "批量结果",
    "batchSummaryTitle": "查询概览",
    "batchSummaryText": "已找到 {found}/{total} 条任务，{unused} 条未使用。",
    "batchSummaryTextWithMissing": "已找到 {found}/{total} 条任务，{unused} 条未使用，{notFound} 条未找到。",
    "batchStatsAria": "批量查询统计",
    "totalQueried": "查询总数",
    "foundCount": "已找到",
    "processingCount": "处理中",
    "failedCount": "失败",
    "unusedCount": "未使用",
    "notFoundCount": "未找到",
    "batchListAria": "批量查询结果列表",
    "accountUnknown": "账号未记录",
    "unusedShort": "未使用",
    "unusedHint": "该兑换码尚未提交兑换订单",
    "unusedWithPlan": "未提交任务 · {plan}",
    "notFoundShort": "未找到",
    "copyUnused": "复制未使用",
    "copyUnusedSuccess": "已复制 {count} 条未使用的兑换码。",
    "copyUnusedFailed": "复制失败，请手动复制。",
    "maxBatchExceeded": "一次最多支持查询 {max} 条兑换码，请拆分后再试。",
    "taskId": "任务ID",
    "cdkCode": "兑换码",
    "subscriptionType": "ChatGPT 套餐",
    "rechargeAccount": "充值账号",
    "currentStatus": "当前状态",
    "failureReason": "失败原因",
    "detailTitle": "任务明细",
    "submitTime": "提交时间",
    "completeTime": "完成时间",
    "queryOther": "查询其他任务",
    "detailActionsAria": "任务操作",
    "copyCdk": "复制兑换码",
    "copyAccount": "复制账号",
    "resubmit": "重新提交",
    "copyCdkSuccess": "已复制兑换码",
    "copyAccountSuccess": "已复制账号",
    "copyActionFailed": "复制失败，请手动复制",
    "selectTaskTitle": "选择任务查看详情",
    "selectTaskHint": "点击左侧任意一条已找到的任务，这里会显示完整明细。",
    "notFoundTitle": "未找到该兑换码对应的订单",
    "notFoundHint": "请检查兑换码是否输入正确",
    "msgPending": "⏳ 任务正在等待处理，请耐心等待...",
    "msgSubmitted": "⚙ 任务正在处理中，请稍候...",
    "msgManualReview": "⏳ 人工处理中，请稍作等待...",
    "msgCompleted": "✓ 任务已完成，您的账号已成功升级",
    "msgFailed": "✗ 任务处理失败，请重新提交或联系客服",
    "resultHeadline": {
      "pending": "等待用户确认",
      "submitted": "后台正在处理",
      "manual_review": "人工处理中",
      "completed": "充值已完成",
      "failed": "充值处理失败"
    },
    "status": {
      "pending": "待处理",
      "submitted": "处理中",
      "manual_review": "人工处理中",
      "completed": "已完成",
      "failed": "失败"
    }
  },
  "subscription": {
    "title": "订阅查询",
    "inputLabel": "输入 Session",
    "inputPlaceholder": "粘贴 chatgpt.com/api/auth/session 的完整 JSON，或直接粘贴 accessToken",
    "inputHint": "仅用于实时查询该账号的订阅状态，不会存储你的 Session。支持完整 session JSON 或 accessToken。",
    "queryBtn": "查询订阅",
    "clear": "清空",
    "queryErrorTitle": "查询失败",
    "queryFailed": "订阅查询失败，请重试",
    "errInvalidInput": "Session 格式不正确，请粘贴完整的 session JSON 或纯 accessToken",
    "errInvalidSession": "Session 无效或已过期，请重新获取后再试",
    "errRateLimited": "查询过于频繁，请稍后再试",
    "resultTitle": "订阅信息",
    "statusActive": "当前订阅有效，自动续费已开启",
    "statusCancelling": "当前订阅有效，但已关闭自动续费",
    "statusInactive": "当前账号没有有效订阅",
    "badgeActive": "订阅有效",
    "badgeInactive": "无订阅",
    "cancelledNotice": "已关闭自动续费，订阅将在到期后停止，不再扣费。",
    "willRenewNotice": "自动续费已开启，将于 {date} 自动扣费续订。",
    "inactiveNotice": "该账号当前没有有效订阅。",
    "yes": "是",
    "no": "否",
    "renewOn": "已开启",
    "renewOff": "已关闭",
    "planFree": "免费版",
    "detailTitle": "详细信息",
    "fieldAccount": "当前账号",
    "fieldPlan": "套餐",
    "fieldActive": "订阅有效",
    "fieldWillRenew": "自动续费",
    "fieldExpires": "到期时间",
    "fieldRenews": "续费时间",
    "fieldCancels": "取消生效时间",
    "fieldBillingPeriod": "计费周期",
    "fieldPlatform": "购买平台",
    "periodMonthly": "每月",
    "periodYearly": "每年",
    "periodWeekly": "每周",
    "platformWeb": "ChatGPT 网页版",
    "platformIos": "iOS（App Store）",
    "platformGoogle": "Android（Google Play）"
  },
  "login": {
    "title": "管理员登录",
    "subtitle": "登录后才能进入管理后台、兑换码管理和订单处理。",
    "username": "用户名",
    "usernamePlaceholder": "请输入用户名",
    "password": "密码",
    "passwordPlaceholder": "请输入密码",
    "rememberPassword": "记住密码",
    "rememberPasswordHint": "仅保存在当前浏览器，取消勾选会清除记录",
    "loginBtn": "登录后台",
    "loggingIn": "登录中...",
    "errLoginFailed": "登录失败",
    "errNetwork": "网络错误，请稍后重试"
  },
  "notFound": {
    "title": "页面不存在",
    "home": "返回首页"
  }
}
